import { ExperimentPlanSummary, isSyntheticControlMethodology } from '@mightyhive/commoncomponents';
import { apiFetch } from '../../utils/api';

interface LibraryPlanTabProps {
  externalUuid: string;
  methodologyType: string | null;
}

export function LibraryPlanTab({ externalUuid, methodologyType }: LibraryPlanTabProps): JSX.Element {
  return (
    <ExperimentPlanSummary
      analysisId={externalUuid}
      apiFetch={apiFetch}
      isSyntheticControl={isSyntheticControlMethodology(methodologyType)}
      readOnly
    />
  );
}
